<div class="main-content">
    <div class="card">
        <p-table #dt [value]="listContactUs"
                 [rows]="row"
                 [first]="first"
                 [totalRecords]="totalRecords"
                 (onPage)="onLazyLoad($event)"
                 [paginator]="true"
                 [lazy]="true"
                 [rowHover]="true"
                 [showCurrentPageReport]="true" [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:11%" pSortableColumn="lastName">{{ 'FEED_BACK.CLIENT_LABEL' | translate }}
                        <p-sortIcon field="lastName"></p-sortIcon>
                    </th>
                    <th style="width:15%">{{ 'CONTACT-US.SUBJECT_LABEL' | translate }}</th>
                    <th>{{ 'CONTACT-US.MESSAGE_LABEL' | translate }}</th>
                    <th style="width:18%">{{ 'CLIENT.EMAIL_LABEL' | translate }}</th>
                    <th style="width:10%">{{ 'CLIENT.PHONE_NUMBER' | translate }}</th>
                    <th style="width:10%">{{ 'FEED_BACK.DATE_LABEL' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contactUs>
                <tr>
                    <td>{{contactUs?.fullName}}</td>
                    <td>{{contactUs?.subject}}</td>
                    <td>{{contactUs?.message}}</td>
                    <td *ngIf="contactUs.userEmail">{{contactUs?.userEmail}}</td>
                    <td *ngIf="!contactUs.userEmail">--</td>
                    <td>{{contactUs?.userPhoneNumber}}</td>
                    <td>{{contactUs?.creationDate | date: 'dd/MM/yyyy, HH:mm':'UTC+1'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
